import clsx from 'clsx';
import { SkeletonText } from './SkeletonText.tsx';

interface SkeletonParagraphProps {
  lines?: 2 | 3 | 4 | 5;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export function SkeletonParagraph({ lines = 2, size = 'sm' }: SkeletonParagraphProps) {
  return (
    <div className={clsx('grid grid-cols-5 gap-x-3')}>
      <div className="col-span-3">
        <SkeletonText size={size} />
      </div>
      <div className="col-span-2">
        <SkeletonText size={size} />
      </div>
      <div className="col-span-5">
        <SkeletonText size={size} />
      </div>
      {lines >= 5 && (
        <div className="col-span-5">
          <SkeletonText size={size} />
        </div>
      )}
      {lines >= 4 && (
        <div className="col-span-5">
          <SkeletonText size={size} />
        </div>
      )}
      {lines >= 3 && (
        <div className="col-span-4">
          <SkeletonText size={size} />
        </div>
      )}
    </div>
  );
}
